import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'

// Mount the app shell (I-0a Batch 3). The error boundary lives in <App/> and
// service-worker registration runs from the shell's effect (app/update/).
const rootElement = document.getElementById('root')
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
